<script>
import appConfig from "@/app.config";

import MovementList from "@/components/Movement-list"

export default {
  page: {
    title: "Documents",
    meta: [{ name: "description", content: appConfig.description }]
  },

  props: {
        api:{
          type:Function,
          default: null
        },
      },

  components: {MovementList},
  data() {
    return {
     // role:null,
      selectedState:null,
      status:null,
      customersList:[],
      selectedCustomer:null,
      selected:null,
      start:null,
      end:null,
      exportInvoicesInProgress : false,
      showAddNewAvoirModal: false ,
      itemTitleprops:null

    };
  }, 
  methods:{

    
 
  },
      
    }

</script>

<style>
  .style-vselect .vs__search {
    line-height: 1;
    color: #394066;
    font-size: 1em
  }

</style>

<template>
  <div>

   
 
 
  

  
  <MovementList  :api="this.api"  />
  </div>
</template>